import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { addBrand } from "../modules/actions";

const mapStateToProps = (state) => ({
  state: {},
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      addBrand,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
